import V, { useMemo as rt, useState as Z, useEffect as z, useContext as $t, useCallback as oe } from "react";
import { makeStyles as h, Typography as P, Avatar as se, SvgIcon as B, Paper as ot, Slide as Bt, useTheme as Ce, useMediaQuery as Ae, Dialog as Ft, Button as at, ButtonBase as Wt, Link as it, DialogActions as st, IconButton as Se, Popover as Mt, withStyles as zt, createStyles as Ut, Badge as Vt, TextField as qt } from "@material-ui/core";
import T from "clsx";
import { createTheme as Kt } from "@material-ui/core/styles";
import Jt from "@material-ui/core/SvgIcon";
import Zt from "@material-ui/core/Typography";
import ae from "js-cookie";
import Qt from "axios";
import { useMutation as lt, queryCache as ct } from "react-query";
var pe = { exports: {} }, M = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ve, Ke;
function ut() {
  if (Ke) return ve;
  Ke = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
  function l(g) {
    if (g == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(g);
  }
  function b() {
    try {
      if (!Object.assign)
        return !1;
      var g = new String("abc");
      if (g[5] = "de", Object.getOwnPropertyNames(g)[0] === "5")
        return !1;
      for (var S = {}, p = 0; p < 10; p++)
        S["_" + String.fromCharCode(p)] = p;
      var x = Object.getOwnPropertyNames(S).map(function(v) {
        return S[v];
      });
      if (x.join("") !== "0123456789")
        return !1;
      var y = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(v) {
        y[v] = v;
      }), Object.keys(Object.assign({}, y)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ve = b() ? Object.assign : function(g, S) {
    for (var p, x = l(g), y, v = 1; v < arguments.length; v++) {
      p = Object(arguments[v]);
      for (var E in p)
        n.call(p, E) && (x[E] = p[E]);
      if (e) {
        y = e(p);
        for (var w = 0; w < y.length; w++)
          i.call(p, y[w]) && (x[y[w]] = p[y[w]]);
      }
    }
    return x;
  }, ve;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Je;
function Xt() {
  if (Je) return M;
  Je = 1, ut();
  var e = V, n = 60103;
  if (M.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var i = Symbol.for;
    n = i("react.element"), M.Fragment = i("react.fragment");
  }
  var l = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, b = Object.prototype.hasOwnProperty, g = { key: !0, ref: !0, __self: !0, __source: !0 };
  function S(p, x, y) {
    var v, E = {}, w = null, D = null;
    y !== void 0 && (w = "" + y), x.key !== void 0 && (w = "" + x.key), x.ref !== void 0 && (D = x.ref);
    for (v in x) b.call(x, v) && !g.hasOwnProperty(v) && (E[v] = x[v]);
    if (p && p.defaultProps) for (v in x = p.defaultProps, x) E[v] === void 0 && (E[v] = x[v]);
    return { $$typeof: n, type: p, key: w, ref: D, props: E, _owner: l.current };
  }
  return M.jsx = S, M.jsxs = S, M;
}
var me = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ze;
function en() {
  return Ze || (Ze = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var n = V, i = ut(), l = 60103, b = 60106;
      e.Fragment = 60107;
      var g = 60108, S = 60114, p = 60109, x = 60110, y = 60112, v = 60113, E = 60120, w = 60115, D = 60116, $ = 60121, q = 60122, K = 60117, Q = 60129, j = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var C = Symbol.for;
        l = C("react.element"), b = C("react.portal"), e.Fragment = C("react.fragment"), g = C("react.strict_mode"), S = C("react.profiler"), p = C("react.provider"), x = C("react.context"), y = C("react.forward_ref"), v = C("react.suspense"), E = C("react.suspense_list"), w = C("react.memo"), D = C("react.lazy"), $ = C("react.block"), q = C("react.server.block"), K = C("react.fundamental"), C("react.scope"), C("react.opaque.id"), Q = C("react.debug_trace_mode"), C("react.offscreen"), j = C("react.legacy_hidden");
      }
      var I = typeof Symbol == "function" && Symbol.iterator, le = "@@iterator";
      function X(t) {
        if (t === null || typeof t != "object")
          return null;
        var o = I && t[I] || t[le];
        return typeof o == "function" ? o : null;
      }
      var N = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function O(t) {
        {
          for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), u = 1; u < o; u++)
            s[u - 1] = arguments[u];
          bt("error", t, s);
        }
      }
      function bt(t, o, s) {
        {
          var u = N.ReactDebugCurrentFrame, R = u.getStackAddendum();
          R !== "" && (o += "%s", s = s.concat([R]));
          var m = s.map(function(f) {
            return "" + f;
          });
          m.unshift("Warning: " + o), Function.prototype.apply.call(console[t], console, m);
        }
      }
      var vt = !1;
      function mt(t) {
        return !!(typeof t == "string" || typeof t == "function" || t === e.Fragment || t === S || t === Q || t === g || t === v || t === E || t === j || vt || typeof t == "object" && t !== null && (t.$$typeof === D || t.$$typeof === w || t.$$typeof === p || t.$$typeof === x || t.$$typeof === y || t.$$typeof === K || t.$$typeof === $ || t[0] === q));
      }
      function Rt(t, o, s) {
        var u = o.displayName || o.name || "";
        return t.displayName || (u !== "" ? s + "(" + u + ")" : s);
      }
      function Te(t) {
        return t.displayName || "Context";
      }
      function H(t) {
        if (t == null)
          return null;
        if (typeof t.tag == "number" && O("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof t == "function")
          return t.displayName || t.name || null;
        if (typeof t == "string")
          return t;
        switch (t) {
          case e.Fragment:
            return "Fragment";
          case b:
            return "Portal";
          case S:
            return "Profiler";
          case g:
            return "StrictMode";
          case v:
            return "Suspense";
          case E:
            return "SuspenseList";
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case x:
              var o = t;
              return Te(o) + ".Consumer";
            case p:
              var s = t;
              return Te(s._context) + ".Provider";
            case y:
              return Rt(t, t.render, "ForwardRef");
            case w:
              return H(t.type);
            case $:
              return H(t._render);
            case D: {
              var u = t, R = u._payload, m = u._init;
              try {
                return H(m(R));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var J = 0, ye, we, ke, je, Oe, Ne, De;
      function Ie() {
      }
      Ie.__reactDisabledLog = !0;
      function pt() {
        {
          if (J === 0) {
            ye = console.log, we = console.info, ke = console.warn, je = console.error, Oe = console.group, Ne = console.groupCollapsed, De = console.groupEnd;
            var t = {
              configurable: !0,
              enumerable: !0,
              value: Ie,
              writable: !0
            };
            Object.defineProperties(console, {
              info: t,
              log: t,
              warn: t,
              error: t,
              group: t,
              groupCollapsed: t,
              groupEnd: t
            });
          }
          J++;
        }
      }
      function xt() {
        {
          if (J--, J === 0) {
            var t = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: i({}, t, {
                value: ye
              }),
              info: i({}, t, {
                value: we
              }),
              warn: i({}, t, {
                value: ke
              }),
              error: i({}, t, {
                value: je
              }),
              group: i({}, t, {
                value: Oe
              }),
              groupCollapsed: i({}, t, {
                value: Ne
              }),
              groupEnd: i({}, t, {
                value: De
              })
            });
          }
          J < 0 && O("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var ce = N.ReactCurrentDispatcher, ue;
      function ee(t, o, s) {
        {
          if (ue === void 0)
            try {
              throw Error();
            } catch (R) {
              var u = R.stack.trim().match(/\n( *(at )?)/);
              ue = u && u[1] || "";
            }
          return `
` + ue + t;
        }
      }
      var de = !1, te;
      {
        var Ct = typeof WeakMap == "function" ? WeakMap : Map;
        te = new Ct();
      }
      function Pe(t, o) {
        if (!t || de)
          return "";
        {
          var s = te.get(t);
          if (s !== void 0)
            return s;
        }
        var u;
        de = !0;
        var R = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var m;
        m = ce.current, ce.current = null, pt();
        try {
          if (o) {
            var f = function() {
              throw Error();
            };
            if (Object.defineProperty(f.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(f, []);
              } catch (Y) {
                u = Y;
              }
              Reflect.construct(t, [], f);
            } else {
              try {
                f.call();
              } catch (Y) {
                u = Y;
              }
              t.call(f.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Y) {
              u = Y;
            }
            t();
          }
        } catch (Y) {
          if (Y && u && typeof Y.stack == "string") {
            for (var d = Y.stack.split(`
`), k = u.stack.split(`
`), A = d.length - 1, _ = k.length - 1; A >= 1 && _ >= 0 && d[A] !== k[_]; )
              _--;
            for (; A >= 1 && _ >= 0; A--, _--)
              if (d[A] !== k[_]) {
                if (A !== 1 || _ !== 1)
                  do
                    if (A--, _--, _ < 0 || d[A] !== k[_]) {
                      var G = `
` + d[A].replace(" at new ", " at ");
                      return typeof t == "function" && te.set(t, G), G;
                    }
                  while (A >= 1 && _ >= 0);
                break;
              }
          }
        } finally {
          de = !1, ce.current = m, xt(), Error.prepareStackTrace = R;
        }
        var W = t ? t.displayName || t.name : "", qe = W ? ee(W) : "";
        return typeof t == "function" && te.set(t, qe), qe;
      }
      function Ge(t, o, s) {
        return Pe(t, !1);
      }
      function At(t) {
        var o = t.prototype;
        return !!(o && o.isReactComponent);
      }
      function ne(t, o, s) {
        if (t == null)
          return "";
        if (typeof t == "function")
          return Pe(t, At(t));
        if (typeof t == "string")
          return ee(t);
        switch (t) {
          case v:
            return ee("Suspense");
          case E:
            return ee("SuspenseList");
        }
        if (typeof t == "object")
          switch (t.$$typeof) {
            case y:
              return Ge(t.render);
            case w:
              return ne(t.type, o, s);
            case $:
              return Ge(t._render);
            case D: {
              var u = t, R = u._payload, m = u._init;
              try {
                return ne(m(R), o, s);
              } catch {
              }
            }
          }
        return "";
      }
      var Ye = {}, He = N.ReactDebugCurrentFrame;
      function re(t) {
        if (t) {
          var o = t._owner, s = ne(t.type, t._source, o ? o.type : null);
          He.setExtraStackFrame(s);
        } else
          He.setExtraStackFrame(null);
      }
      function St(t, o, s, u, R) {
        {
          var m = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var f in t)
            if (m(t, f)) {
              var d = void 0;
              try {
                if (typeof t[f] != "function") {
                  var k = Error((u || "React class") + ": " + s + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw k.name = "Invariant Violation", k;
                }
                d = t[f](o, f, u, s, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (A) {
                d = A;
              }
              d && !(d instanceof Error) && (re(R), O("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", u || "React class", s, f, typeof d), re(null)), d instanceof Error && !(d.message in Ye) && (Ye[d.message] = !0, re(R), O("Failed %s type: %s", s, d.message), re(null));
            }
        }
      }
      var Le = N.ReactCurrentOwner, fe = Object.prototype.hasOwnProperty, Et = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, $e, Be;
      function _t(t) {
        if (fe.call(t, "ref")) {
          var o = Object.getOwnPropertyDescriptor(t, "ref").get;
          if (o && o.isReactWarning)
            return !1;
        }
        return t.ref !== void 0;
      }
      function Tt(t) {
        if (fe.call(t, "key")) {
          var o = Object.getOwnPropertyDescriptor(t, "key").get;
          if (o && o.isReactWarning)
            return !1;
        }
        return t.key !== void 0;
      }
      function yt(t, o) {
        typeof t.ref == "string" && Le.current;
      }
      function wt(t, o) {
        {
          var s = function() {
            $e || ($e = !0, O("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", o));
          };
          s.isReactWarning = !0, Object.defineProperty(t, "key", {
            get: s,
            configurable: !0
          });
        }
      }
      function kt(t, o) {
        {
          var s = function() {
            Be || (Be = !0, O("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", o));
          };
          s.isReactWarning = !0, Object.defineProperty(t, "ref", {
            get: s,
            configurable: !0
          });
        }
      }
      var jt = function(t, o, s, u, R, m, f) {
        var d = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: l,
          // Built-in properties that belong on the element
          type: t,
          key: o,
          ref: s,
          props: f,
          // Record the component responsible for creating this element.
          _owner: m
        };
        return d._store = {}, Object.defineProperty(d._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(d, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: u
        }), Object.defineProperty(d, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: R
        }), Object.freeze && (Object.freeze(d.props), Object.freeze(d)), d;
      };
      function Ot(t, o, s, u, R) {
        {
          var m, f = {}, d = null, k = null;
          s !== void 0 && (d = "" + s), Tt(o) && (d = "" + o.key), _t(o) && (k = o.ref, yt(o, R));
          for (m in o)
            fe.call(o, m) && !Et.hasOwnProperty(m) && (f[m] = o[m]);
          if (t && t.defaultProps) {
            var A = t.defaultProps;
            for (m in A)
              f[m] === void 0 && (f[m] = A[m]);
          }
          if (d || k) {
            var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
            d && wt(f, _), k && kt(f, _);
          }
          return jt(t, d, k, R, u, Le.current, f);
        }
      }
      var he = N.ReactCurrentOwner, Fe = N.ReactDebugCurrentFrame;
      function F(t) {
        if (t) {
          var o = t._owner, s = ne(t.type, t._source, o ? o.type : null);
          Fe.setExtraStackFrame(s);
        } else
          Fe.setExtraStackFrame(null);
      }
      var ge;
      ge = !1;
      function be(t) {
        return typeof t == "object" && t !== null && t.$$typeof === l;
      }
      function We() {
        {
          if (he.current) {
            var t = H(he.current.type);
            if (t)
              return `

Check the render method of \`` + t + "`.";
          }
          return "";
        }
      }
      function Nt(t) {
        return "";
      }
      var Me = {};
      function Dt(t) {
        {
          var o = We();
          if (!o) {
            var s = typeof t == "string" ? t : t.displayName || t.name;
            s && (o = `

Check the top-level render call using <` + s + ">.");
          }
          return o;
        }
      }
      function ze(t, o) {
        {
          if (!t._store || t._store.validated || t.key != null)
            return;
          t._store.validated = !0;
          var s = Dt(o);
          if (Me[s])
            return;
          Me[s] = !0;
          var u = "";
          t && t._owner && t._owner !== he.current && (u = " It was passed a child from " + H(t._owner.type) + "."), F(t), O('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', s, u), F(null);
        }
      }
      function Ue(t, o) {
        {
          if (typeof t != "object")
            return;
          if (Array.isArray(t))
            for (var s = 0; s < t.length; s++) {
              var u = t[s];
              be(u) && ze(u, o);
            }
          else if (be(t))
            t._store && (t._store.validated = !0);
          else if (t) {
            var R = X(t);
            if (typeof R == "function" && R !== t.entries)
              for (var m = R.call(t), f; !(f = m.next()).done; )
                be(f.value) && ze(f.value, o);
          }
        }
      }
      function It(t) {
        {
          var o = t.type;
          if (o == null || typeof o == "string")
            return;
          var s;
          if (typeof o == "function")
            s = o.propTypes;
          else if (typeof o == "object" && (o.$$typeof === y || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          o.$$typeof === w))
            s = o.propTypes;
          else
            return;
          if (s) {
            var u = H(o);
            St(s, t.props, "prop", u, t);
          } else if (o.PropTypes !== void 0 && !ge) {
            ge = !0;
            var R = H(o);
            O("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
          }
          typeof o.getDefaultProps == "function" && !o.getDefaultProps.isReactClassApproved && O("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Pt(t) {
        {
          for (var o = Object.keys(t.props), s = 0; s < o.length; s++) {
            var u = o[s];
            if (u !== "children" && u !== "key") {
              F(t), O("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", u), F(null);
              break;
            }
          }
          t.ref !== null && (F(t), O("Invalid attribute `ref` supplied to `React.Fragment`."), F(null));
        }
      }
      function Ve(t, o, s, u, R, m) {
        {
          var f = mt(t);
          if (!f) {
            var d = "";
            (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (d += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var k = Nt();
            k ? d += k : d += We();
            var A;
            t === null ? A = "null" : Array.isArray(t) ? A = "array" : t !== void 0 && t.$$typeof === l ? (A = "<" + (H(t.type) || "Unknown") + " />", d = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, O("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, d);
          }
          var _ = Ot(t, o, s, R, m);
          if (_ == null)
            return _;
          if (f) {
            var G = o.children;
            if (G !== void 0)
              if (u)
                if (Array.isArray(G)) {
                  for (var W = 0; W < G.length; W++)
                    Ue(G[W], t);
                  Object.freeze && Object.freeze(G);
                } else
                  O("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ue(G, t);
          }
          return t === e.Fragment ? Pt(_) : It(_), _;
        }
      }
      function Gt(t, o, s) {
        return Ve(t, o, s, !0);
      }
      function Yt(t, o, s) {
        return Ve(t, o, s, !1);
      }
      var Ht = Yt, Lt = Gt;
      e.jsx = Ht, e.jsxs = Lt;
    }();
  }(me)), me;
}
process.env.NODE_ENV === "production" ? pe.exports = Xt() : pe.exports = en();
var a = pe.exports;
const r = {
  BACKGROUND: "#F3F3F1",
  ERROR: "#EE0000",
  GRAY: "#7A766D",
  GRAY_10: "#DFDFD8",
  GRAY_SHADE: "#302E28",
  LIGHT_GRAY: "#A9A59C",
  LIGHT_GRAY_30: "#D2CFC7",
  ORANGE: "#EFAA59",
  PRIMARY: "#5FAF85",
  PRIMARY_SHADE: "#257A4E",
  PRIMARY_10: "#DBFEEC",
  SECONDARY: "#FD7662",
  SECONDARY_SHADE: "#C75341",
  TEAL: "#26647E",
  TERTIARY: "#71D8E5",
  TERTIARY_SHADE: "#12707D",
  TERTIARY_VARIANT: "#37B8CA",
  TERTIARY_10: "#D5F9FE",
  TERTIARY_HOVER: "#00E2FF",
  WARNING: "#EFAA59",
  WARNING_10: "#FFF0DF",
  WHITE: "#FFFFFF",
  TRANSPARENT_BORDER: "rgba(48, 46, 40, 0.1)"
}, tn = (e) => {
  const n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return n ? {
    r: parseInt(n[1], 16),
    g: parseInt(n[2], 16),
    b: parseInt(n[3], 16)
  } : {
    r: 25,
    g: 144,
    b: 84
  };
}, Ee = (e, n) => {
  const { r: i, g: l, b } = tn(e);
  return `rgba(${i}, ${l}, ${b}, ${n})`;
}, nn = 16, c = (e) => `${(e / nn).toFixed(4)}rem`, br = Kt({
  palette: {
    primary: {
      main: r.SECONDARY,
      contrastText: "#FFF"
    },
    secondary: {
      main: "#FFF"
    }
  },
  typography: {
    fontFamily: ["Poppins", "sans-serif"].join(","),
    h1: {
      fontSize: c(44),
      fontFamily: ["Aleo", "serif"].join(","),
      lineHeight: c(53),
      fontWeight: "bold"
    },
    h2: {
      fontSize: c(24),
      lineHeight: c(30),
      fontWeight: 600,
      color: r.GRAY_SHADE
    },
    h3: {
      fontSize: c(18),
      fontFamily: ["Aleo", "serif"].join(","),
      lineHeight: c(22),
      fontWeight: "bold",
      color: r.GRAY_SHADE
    },
    h4: {
      fontSize: c(16),
      lineHeight: c(20),
      fontWeight: 600,
      color: r.GRAY_SHADE
    },
    h5: {
      fontSize: c(14),
      lineHeight: c(21),
      fontWeight: 600,
      color: r.GRAY_SHADE
    },
    h6: {
      fontSize: c(12),
      lineHeight: c(18),
      fontWeight: 600,
      color: r.GRAY_SHADE
    },
    body1: {
      // P1
      fontSize: c(18),
      lineHeight: c(27)
    },
    body2: {
      // P2
      fontSize: c(16),
      lineHeight: c(24)
    },
    subtitle1: {
      // Smalltext
      fontSize: c(10),
      lineHeight: c(15),
      fontWeight: 600
    },
    button: {
      color: "backgroundLight",
      textTransform: "none",
      fontSize: c(16),
      lineHeight: c(24),
      fontWeight: 600
    }
  },
  breakpoints: {
    values: {
      xl: 1280,
      lg: 950,
      md: 750,
      sm: 475,
      xs: 0
    }
  },
  overrides: {
    MuiListItem: {
      button: {
        margin: "4px 0",
        borderRadius: 8,
        "&:hover": {
          backgroundColor: r.BACKGROUND
        }
      }
    },
    MuiListItemText: {
      primary: {
        color: r.GRAY,
        textShadow: "none",
        fontSize: c(12),
        lineHeight: c(18),
        fontWeight: 600
      },
      secondary: {
        fontSize: c(14),
        lineHeight: c(21),
        fontWeight: 600
      }
    },
    MuiListItemIcon: {
      root: {
        color: r.GRAY
      }
    },
    MuiButton: {
      text: {},
      root: {
        borderRadius: 8
      },
      contained: {
        boxShadow: "none"
      },
      sizeSmall: {
        fontSize: c(12),
        lineHeight: c(18),
        fontWeight: 600,
        padding: "11px 20px"
      },
      sizeLarge: {
        fontSize: c(12),
        lineHeight: c(18),
        fontWeight: 600,
        padding: "11px 20px"
        // fontSize: getRemFromPx(16),
        // lineHeight: getRemFromPx(24),
        // fontWeight: 600,
        // padding: '15px 40px'
      },
      containedSecondary: {
        border: `1px solid ${r.LIGHT_GRAY_30}`,
        "&:hover": {
          backgroundColor: r.BACKGROUND,
          boxShadow: "none"
        }
      }
    },
    MuiTabs: {
      indicator: {
        height: 4
      }
    },
    MuiTab: {
      root: {
        color: r.GRAY_SHADE,
        textShadow: "none",
        fontSize: `${c(12)} !important`,
        lineHeight: `${c(18)} !important`,
        fontWeight: 600
      }
    },
    MuiInput: {
      input: {
        paddingTop: 16,
        "&::placeholder": {
          paddingTop: 16
        }
      }
    },
    MuiPaper: {
      root: {
        background: "#FFFFFF"
      },
      elevation1: {
        boxShadow: "0px 3px 3px rgba(0, 0, 0, 0.03)"
      },
      rounded: {
        borderRadius: 16
      }
    },
    MuiPopover: {
      paper: {
        boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.12)"
      }
    },
    MuiTableCell: {
      head: {
        textShadow: "none",
        fontSize: c(13),
        lineHeight: c(19),
        color: r.GRAY
      }
    }
  }
}), rn = V.forwardRef((e, n) => {
  const i = on();
  return /* @__PURE__ */ a.jsx(P, { ref: n, component: "p", className: T(i.p4, e.className ? e.className : null), children: e.children });
}), on = h(() => ({
  p4: {
    fontSize: 10,
    lineHeight: c(15)
  }
})), an = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 }, sn = (e) => {
  const n = e.replace("REACT_APP_", "VITE_");
  return an[n];
}, dt = (e) => {
  const n = ln();
  return /* @__PURE__ */ a.jsx(P, { component: "div", className: T(n.p3, e.className ? e.className : null), children: e.children });
}, ln = h((e) => ({
  p3: {
    color: r.GRAY,
    textShadow: "none",
    fontSize: c(13),
    lineHeight: c(19),
    [e.breakpoints.up("md")]: {
      fontSize: c(12),
      lineHeight: c(18)
    }
  }
})), vr = (e) => {
  const n = cn();
  return /* @__PURE__ */ a.jsx(P, { component: "div", className: T(n.handwritten, e.className ? e.className : null), children: e.children });
}, cn = h((e) => ({
  handwritten: {
    color: r.GRAY,
    fontFamily: "Indie Flower",
    textShadow: "none",
    fontSize: c(15),
    lineHeight: c(22)
  }
})), mr = (e) => {
  const n = un();
  return /* @__PURE__ */ a.jsx(P, { component: "p", className: T(n.h7, e.className ? e.className : null), children: e.children });
}, un = h(() => ({
  h7: {
    color: r.GRAY,
    fontWeight: 500,
    fontSize: c(10),
    lineHeight: c(15)
  }
})), dn = (e) => {
  const n = fn();
  return /* @__PURE__ */ a.jsx(P, { className: T(n.link, e.className ? e.className : null), children: e.children });
}, fn = h((e) => ({
  link: {
    textShadow: "none",
    display: "flex",
    fontSize: c(12),
    lineHeight: c(18),
    fontWeight: 600,
    color: r.GRAY_SHADE,
    textDecoration: "none",
    [e.breakpoints.down("sm")]: {
      fontSize: c(16),
      lineHeight: c(24)
    }
  }
})), Rr = (e) => {
  const n = hn();
  return /* @__PURE__ */ a.jsx(P, { component: "p", className: T(n.smallText, e.className ? e.className : null), children: e.children });
}, hn = h(() => ({
  smallText: {
    textShadow: "none",
    fontWeight: 600,
    fontSize: c(10),
    lineHeight: c(15)
  }
}));
var gn = "M12.75,3.94C13.75,3.22 14.91,2.86 16.22,2.86C16.94,2.86 17.73,3.05 18.59,3.45C19.45,3.84 20.13,4.3 20.63,4.83C21.66,6.11 22.09,7.6 21.94,9.3C21.78,11 21.22,12.33 20.25,13.27L12.66,20.86C12.47,21.05 12.23,21.14 11.95,21.14C11.67,21.14 11.44,21.05 11.25,20.86C11.06,20.67 10.97,20.44 10.97,20.16C10.97,19.88 11.06,19.64 11.25,19.45L15.84,14.86C16.09,14.64 16.09,14.41 15.84,14.16C15.59,13.91 15.36,13.91 15.14,14.16L10.55,18.75C10.36,18.94 10.13,19.03 9.84,19.03C9.56,19.03 9.33,18.94 9.14,18.75C8.95,18.56 8.86,18.33 8.86,18.05C8.86,17.77 8.95,17.53 9.14,17.34L13.73,12.75C14,12.5 14,12.25 13.73,12C13.5,11.75 13.28,11.75 13.03,12L8.44,16.64C8.25,16.83 8,16.92 7.73,16.92C7.45,16.92 7.21,16.83 7,16.64C6.8,16.45 6.7,16.22 6.7,15.94C6.7,15.66 6.81,15.41 7.03,15.19L11.63,10.59C11.88,10.34 11.88,10.11 11.63,9.89C11.38,9.67 11.14,9.67 10.92,9.89L6.28,14.5C6.06,14.7 5.83,14.81 5.58,14.81C5.3,14.81 5.06,14.71 4.88,14.5C4.69,14.3 4.59,14.06 4.59,13.78C4.59,13.5 4.69,13.27 4.88,13.08C7.94,10 9.83,8.14 10.55,7.45L14.11,10.97C14.5,11.34 14.95,11.53 15.5,11.53C16.2,11.53 16.75,11.25 17.16,10.69C17.44,10.28 17.54,9.83 17.46,9.33C17.38,8.83 17.17,8.41 16.83,8.06L12.75,3.94M14.81,10.27L10.55,6L3.47,13.08C2.63,12.23 2.15,10.93 2.04,9.16C1.93,7.4 2.41,5.87 3.47,4.59C4.66,3.41 6.08,2.81 7.73,2.81C9.39,2.81 10.8,3.41 11.95,4.59L16.22,8.86C16.41,9.05 16.5,9.28 16.5,9.56C16.5,9.84 16.41,10.08 16.22,10.27C16.03,10.45 15.8,10.55 15.5,10.55C15.23,10.55 15,10.45 14.81,10.27V10.27Z", ft = "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z", bn = "M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z", vn = "M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7A2,2 0 0,0 10,9H8A4,4 0 0,1 12,5A4,4 0 0,1 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z", mn = "M19,12C19,15.86 15.86,19 12,19C8.14,19 5,15.86 5,12C5,8.14 8.14,5 12,5C15.86,5 19,8.14 19,12Z";
const Rn = (e) => {
  const n = e.replace(/[^a-zA-Z ]/g, "").split(" ").filter((b) => b !== "");
  if (n.length === 0)
    return "4G";
  if (n.length === 1) {
    const b = n[0][0], g = n[0][1] ? n[0][1] : "";
    return `${b}${g}`.toUpperCase();
  }
  const i = n[0][0], l = n[n.length - 1][0];
  return `${i}${l}`.toUpperCase();
};
r.TERTIARY, r.PRIMARY, r.SECONDARY, r.WARNING;
const Qe = (e) => {
  const n = pn(), i = e.url && e.url.indexOf("cdn.auth0.com%2Favatars") === -1 ? e.url : "", l = Rn(e.label);
  return /* @__PURE__ */ a.jsx(
    se,
    {
      src: i,
      className: T(n.avatar, e.className, {
        [n.small]: e.size === "small",
        [n.large]: e.size === "large",
        [n.medium]: e.size === "medium",
        [n.user]: e.type === "user"
      }),
      children: e.type === "user" ? l : /* @__PURE__ */ a.jsx(B, { className: n.nonProfit, children: /* @__PURE__ */ a.jsx("path", { d: gn }) })
    }
  );
}, pn = h((e) => ({
  avatar: {
    backgroundColor: r.BACKGROUND,
    border: `1px solid ${r.TRANSPARENT_BORDER}`
  },
  nonProfit: {
    color: r.SECONDARY
  },
  user: {
    fontSize: 14,
    fontWeight: 600,
    color: r.TERTIARY
  },
  small: {
    width: 24,
    height: 24
  },
  medium: {
    height: 35,
    width: 35
  },
  large: {
    height: 88,
    width: 88
  }
})), pr = (e) => {
  const n = xn();
  return /* @__PURE__ */ a.jsx(ot, { className: T(
    n.container,
    e.className,
    {
      [n.padding]: e.withPadding
    }
  ), children: e.children });
}, xn = h((e) => ({
  container: {
    borderRadius: 8
  },
  padding: {
    padding: 15
  }
})), xr = (e) => {
  const n = Cn();
  return /* @__PURE__ */ a.jsxs(rn, { className: n.p4, children: [
    /* @__PURE__ */ a.jsx("span", { className: n.numbers, children: e.count }),
    " of ",
    /* @__PURE__ */ a.jsx("span", { className: n.numbers, children: e.limit }),
    " ",
    "characters"
  ] });
}, Cn = h((e) => ({
  p4: {
    color: r.GRAY
  },
  wrapper: {
    margin: "4px 10px 10px 10px"
  },
  numbers: {
    color: r.GRAY,
    fontWeight: "bold"
  }
})), Cr = (e) => {
  const n = An({ baseColor: e.baseColor });
  return /* @__PURE__ */ a.jsxs(ot, { className: n.noEntryContainer, children: [
    /* @__PURE__ */ a.jsx(se, { className: n.loadingAvatar, children: /* @__PURE__ */ a.jsx(B, { children: /* @__PURE__ */ a.jsx("path", { d: e.iconPath }) }) }),
    /* @__PURE__ */ a.jsx(P, { variant: "h5", className: n.loadingH5, children: e.title }),
    /* @__PURE__ */ a.jsx(dt, { className: n.loadingP3, children: e.description })
  ] });
}, An = h((e) => ({
  noEntryContainer: {
    marginTop: 20,
    flexDirection: "column",
    display: "flex",
    height: 277,
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center"
  },
  loadingAvatar: {
    backgroundColor: (n) => Ee(n.baseColor, 0.15),
    "& svg": {
      color: (n) => n.baseColor
    }
  },
  loadingH5: {
    paddingTop: 17,
    color: r.GRAY
  },
  loadingP3: {
    maxWidth: "80%",
    paddingTop: 5,
    color: r.GRAY
  }
})), Sn = V.forwardRef(function(n, i) {
  return /* @__PURE__ */ a.jsx(Bt, { direction: "up", ref: i, ...n });
}), Ar = (e) => {
  const n = En(), i = Ce(), l = Ae(i.breakpoints.down("sm"));
  return /* @__PURE__ */ a.jsx(
    Ft,
    {
      style: e.style,
      onClose: e.closeDialog,
      fullScreen: e.fullScreen ? e.fullScreen : l,
      open: e.open,
      TransitionComponent: Sn,
      disableEnforceFocus: e.disableEnforceFocus,
      classes: { paper: T(e.fullScreen ? null : n.paperContainer, e.containerClass) },
      children: e.children
    }
  );
}, En = h((e) => ({
  paperContainer: {
    [e.breakpoints.up("md")]: {
      minWidth: 620,
      maxWidth: 620,
      minHeight: 550
    }
  }
})), L = (e) => {
  const { children: n, buttonSizeOverride: i, ...l } = e, b = Ce(), g = Ae(b.breakpoints.down("sm")), S = i || (g ? "large" : "small");
  return /* @__PURE__ */ a.jsx(at, { ...l, size: S, children: n });
}, Sr = (e) => {
  const n = _n(), { children: i, ...l } = e;
  return /* @__PURE__ */ a.jsx(
    L,
    {
      ...l,
      disableRipple: !0,
      classes: {
        root: n.root
      },
      children: i
    }
  );
}, _n = h((e) => ({
  root: {
    borderRadius: 4,
    flex: 1,
    justifyContent: "flex-start",
    "&:disabled": {
      color: r.GRAY_10
    }
  }
})), Tn = (e) => {
  const n = yn(), { children: i, ...l } = e;
  return /* @__PURE__ */ a.jsx(
    L,
    {
      variant: e.variant ? e.variant : "contained",
      ...l,
      disableRipple: !0,
      classes: {
        root: n.root,
        contained: n.contained,
        outlined: n.outlined
      },
      children: i
    }
  );
}, yn = h((e) => ({
  root: {
    "&:disabled": {
      color: r.GRAY_10
    }
  },
  contained: {
    color: r.WHITE,
    backgroundColor: r.PRIMARY,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: r.PRIMARY_SHADE,
      boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.12)"
    },
    "&:focusVisible": {
      backgroundColor: r.PRIMARY
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: r.PRIMARY
    },
    "&:disabled": {
      color: r.WHITE,
      backgroundColor: r.GRAY_10
    }
  },
  outlined: {
    color: r.PRIMARY,
    borderColor: r.PRIMARY,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: r.WHITE,
      boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.12)"
    },
    "&:focusVisible": {},
    "&:active": {
      boxShadow: "none"
    },
    "&:disabled": {}
  }
})), ht = (e) => {
  const n = wn(), { children: i, ...l } = e;
  return /* @__PURE__ */ a.jsx(
    L,
    {
      variant: "contained",
      ...l,
      disableRipple: !0,
      classes: {
        root: n.root,
        contained: n.contained
      },
      children: i
    }
  );
}, wn = h((e) => ({
  root: {
    "&:disabled": {
      color: r.GRAY_10
    }
  },
  contained: {
    color: r.WHITE,
    backgroundColor: r.SECONDARY,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#DA5441",
      boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.12)"
    },
    "&:focusVisible": {
      backgroundColor: r.SECONDARY
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: r.SECONDARY
    },
    "&:disabled": {
      color: r.WHITE,
      backgroundColor: r.GRAY_10
    }
  }
})), ie = (e) => {
  const n = kn(), { children: i, ...l } = e;
  return /* @__PURE__ */ a.jsx(
    L,
    {
      variant: "outlined",
      ...l,
      disableRipple: !0,
      classes: {
        root: n.root,
        outlined: n.outlined
      },
      children: i
    }
  );
}, kn = h((e) => ({
  root: {
    "&:disabled": {
      color: r.GRAY_10
    }
  },
  outlined: {
    border: `1px solid ${r.TRANSPARENT_BORDER}`,
    color: r.GRAY_SHADE,
    backgroundColor: "transparent",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: r.WHITE,
      boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.12)"
    },
    "&:focusVisible": {
      backgroundColor: r.WHITE
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: r.WHITE
    },
    "&:disabled": {
      color: r.LIGHT_GRAY_30,
      borderColor: r.LIGHT_GRAY_30
    }
  }
})), Er = (e) => {
  const n = jn(), { children: i, ...l } = e;
  return /* @__PURE__ */ a.jsx(
    L,
    {
      ...l,
      variant: "contained",
      disableRipple: !0,
      classes: {
        root: n.root,
        contained: n.contained
      },
      children: i
    }
  );
}, jn = h((e) => ({
  root: {
    borderRadius: 8,
    "&:disabled": {
      color: r.GRAY_10
    },
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.07)"
  },
  contained: {
    color: r.GRAY_SHADE,
    backgroundColor: r.WHITE,
    "&:hover": {
      boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.12);",
      backgroundColor: r.WHITE
    },
    "&:focusVisible": {
      boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.12);",
      backgroundColor: r.WHITE
    },
    "&:active": {
      boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.12);",
      backgroundColor: r.WHITE
    },
    "&:disabled": {
      color: r.LIGHT_GRAY,
      backgroundColor: r.BACKGROUND
    }
  }
})), _r = (e) => {
  const n = On({
    selected: e.selected,
    colorOverride: e.colorOverride
  }), i = {};
  return e.onClick ? i.onClick = e.onClick : e.href && (i.component = it, i.href = e.href), /* @__PURE__ */ a.jsxs("div", { className: n.localContainer, children: [
    /* @__PURE__ */ a.jsxs(Wt, { className: n.buttonBaseContainer, ...i, children: [
      e.iconPath && /* @__PURE__ */ a.jsx(Jt, { className: n.icon, children: /* @__PURE__ */ a.jsx("path", { d: e.iconPath }) }),
      e.iconElement,
      /* @__PURE__ */ a.jsx(Zt, { variant: "h6", className: n.h6, children: e.title })
    ] }),
    e.selected && /* @__PURE__ */ a.jsx("span", { className: n.selected })
  ] });
}, On = h((e) => ({
  localContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "center"
  },
  buttonBaseContainer: {
    padding: 5,
    margin: "0 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "column",
    height: 55,
    textDecoration: "none !important"
  },
  h6: {
    color: (n) => n.colorOverride ? n.colorOverride : r.GRAY
  },
  icon: {
    color: (n) => n.colorOverride ? n.colorOverride : n.selected ? r.SECONDARY : r.LIGHT_GRAY
  },
  selected: {
    backgroundColor: r.SECONDARY,
    height: 4,
    position: "absolute",
    bottom: -12,
    width: "80%"
  }
})), Tr = (e) => {
  const n = Nn(), { children: i, ...l } = e;
  return /* @__PURE__ */ a.jsx(
    L,
    {
      ...l,
      variant: "outlined",
      disableRipple: !0,
      classes: {
        root: n.root,
        outlined: n.outlined
      },
      children: i
    }
  );
}, Nn = h((e) => ({
  root: {
    paddingLeft: 0,
    paddingRight: 0,
    "&:disabled": {
      backgroundColor: "transparent",
      color: r.GRAY_10
    }
  },
  outlined: {
    border: "none",
    color: r.GRAY_SHADE,
    backgroundColor: "transparent",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "transparent",
      textDecoration: "underline"
    },
    "&:focusVisible": {
      backgroundColor: "transparent",
      textDecoration: "underline"
    },
    "&:active": {
      backgroundColor: "transparent",
      textDecoration: "underline"
    },
    "&:disabled": {
      backgroundColor: "transparent",
      color: r.LIGHT_GRAY_30
    }
  }
})), yr = (e) => {
  const n = Dn(), { children: i, ...l } = e;
  return /* @__PURE__ */ a.jsx(
    L,
    {
      variant: "contained",
      ...l,
      disableRipple: !0,
      classes: {
        root: n.root,
        contained: n.contained
      },
      children: i
    }
  );
}, Dn = h((e) => ({
  root: {
    "&:disabled": {
      color: r.GRAY_10
    }
  },
  contained: {
    color: r.WHITE,
    backgroundColor: r.ERROR,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: Ee(r.ERROR, 0.9),
      boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.12)"
    },
    "&:focusVisible": {
      backgroundColor: r.ERROR
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: r.ERROR
    },
    "&:disabled": {
      color: r.WHITE,
      backgroundColor: r.GRAY_10
    }
  }
})), In = (e) => {
  const n = Pn(), { children: i, buttonSizeOverride: l, ...b } = e, g = Ce(), S = Ae(g.breakpoints.down("sm")), p = l || (S ? "large" : "small");
  return /* @__PURE__ */ a.jsx(
    at,
    {
      ...b,
      variant: "outlined",
      disableRipple: !0,
      classes: {
        root: T(n.root, p === "large" ? n.largeButton : n.smallButton),
        outlined: n.outlined
      },
      children: i
    }
  );
}, Pn = h((e) => ({
  root: {
    margin: 8,
    borderRadius: 8,
    "&:disabled": {
      backgroundColor: "transparent",
      color: r.GRAY_10
    }
  },
  largeButton: {
    // mobile
    fontSize: c(16),
    lineHeight: c(24),
    fontWeight: 600,
    padding: "12px 15px"
  },
  smallButton: {
    // desktop
    fontSize: c(12),
    lineHeight: c(18),
    fontWeight: 600,
    padding: "10px 17px"
  },
  outlined: {
    border: "none",
    color: r.GRAY_SHADE,
    backgroundColor: "transparent",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: r.BACKGROUND
    },
    "&:focusVisible": {
      backgroundColor: r.BACKGROUND
    },
    "&:active": {
      backgroundColor: r.BACKGROUND
    },
    "&:disabled": {
      backgroundColor: "transparent",
      color: r.LIGHT_GRAY_30
    }
  }
})), wr = (e) => {
  const n = Gn(), { selectedIndex: i, setSelectedIndex: l } = e, b = e.selectedButtonClass || n.selectedButton;
  return /* @__PURE__ */ a.jsx("div", { className: T(n.buttonContainer, e.buttonContainerClass), children: e.buttonsConfig.map((g, S) => /* @__PURE__ */ a.jsx(
    In,
    {
      onClick: () => {
        l(S);
      },
      className: T(
        n.button,
        e.customButtonClass,
        i === S ? b : null
      ),
      startIcon: g.startIcon,
      children: g.label
    },
    g.label
  )) });
}, Gn = h((e) => ({
  buttonContainer: {
    borderRadius: 8,
    backgroundColor: "#fff"
  },
  button: {
    color: r.GRAY
  },
  selectedButton: {
    backgroundColor: r.BACKGROUND,
    color: r.GRAY_SHADE
  }
})), kr = (e) => {
  const n = Yn(), { children: i, ...l } = e;
  return /* @__PURE__ */ a.jsx(
    L,
    {
      variant: "contained",
      ...l,
      disableRipple: !0,
      classes: {
        root: n.root,
        contained: n.contained
      },
      children: i
    }
  );
}, Yn = h((e) => ({
  root: {
    "&:disabled": {
      color: r.GRAY_10
    }
  },
  contained: {
    color: r.WHITE,
    backgroundColor: r.WARNING,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: Ee(r.WARNING, 0.9),
      boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.12)"
    },
    "&:focusVisible": {
      backgroundColor: r.WARNING
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: r.WARNING
    },
    "&:disabled": {
      color: r.WHITE,
      backgroundColor: r.GRAY_10
    }
  }
})), jr = (e) => {
  const n = Hn();
  return /* @__PURE__ */ a.jsxs(
    st,
    {
      classes: {
        root: T(n.containerRoot, e.className)
      },
      children: [
        /* @__PURE__ */ a.jsx(
          ie,
          {
            className: n.cancel,
            href: e.helpLink,
            component: it,
            variant: "outlined",
            startIcon: /* @__PURE__ */ a.jsx(B, { className: n.icon, children: /* @__PURE__ */ a.jsx("path", { d: vn }) }),
            children: e.helpLabel ? e.helpLabel : "Help"
          }
        ),
        /* @__PURE__ */ a.jsxs("div", { className: n.actions, children: [
          e.cancelAction && /* @__PURE__ */ a.jsx(ie, { variant: "outlined", onClick: e.cancelAction, className: n.cancel, children: e.cancelLabel ? e.cancelLabel : "Cancel" }),
          e.saveAction && /* @__PURE__ */ a.jsx(
            Tn,
            {
              variant: "contained",
              onClick: e.saveAction,
              className: n.button,
              disabled: e.disableSave,
              children: e.saveLabel ? e.saveLabel : "Save"
            }
          )
        ] })
      ]
    }
  );
}, Hn = h((e) => ({
  icon: {
    color: r.TERTIARY
  },
  containerRoot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "21px 24px",
    [e.breakpoints.down("md")]: {
      padding: "26px 23px"
    },
    borderTop: `1px solid ${r.TRANSPARENT_BORDER}`
  },
  button: {
    [e.breakpoints.down("md")]: {
      width: "100%"
    }
  },
  cancel: {
    [e.breakpoints.down("md")]: {
      display: "none"
    }
  },
  actions: {
    "& :not(:first-child)": {
      marginLeft: 8,
      [e.breakpoints.down("md")]: {
        marginLeft: 0
      }
    },
    [e.breakpoints.down("md")]: {
      marginLeft: "0 !important",
      width: "100%"
    }
  }
})), Or = (e) => {
  const n = Ln();
  return /* @__PURE__ */ a.jsxs(
    st,
    {
      classes: {
        root: T(n.containerRoot, e.containerClass)
      },
      children: [
        e.children,
        e.cancelAction && /* @__PURE__ */ a.jsx(ie, { variant: "outlined", onClick: e.cancelAction, className: n.cancel, children: "Cancel" }),
        e.saveAction && /* @__PURE__ */ a.jsx(
          ht,
          {
            variant: "contained",
            onClick: e.saveAction,
            className: n.button,
            disabled: e.disableSave,
            children: "Save"
          }
        )
      ]
    }
  );
}, Ln = h((e) => ({
  containerRoot: {
    padding: 25
  },
  button: {
    [e.breakpoints.down("md")]: {
      width: "100%"
    }
  },
  cancel: {
    [e.breakpoints.down("md")]: {
      display: "none"
    }
  }
})), Nr = (e) => {
  const n = $n();
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsxs("div", { className: T(n.dialogTitle, n.displayDesktop), children: [
      /* @__PURE__ */ a.jsx(
        ie,
        {
          disabled: e.disableCancel,
          variant: "outlined",
          onClick: e.handleCancel,
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ a.jsx(dn, { children: e.title }),
      /* @__PURE__ */ a.jsx(ht, { variant: "contained", onClick: e.handleSave, disabled: e.disableSave, children: "Done" })
    ] }),
    /* @__PURE__ */ a.jsxs("div", { className: T(n.dialogTitle, n.displayMobile), children: [
      /* @__PURE__ */ a.jsx(P, { variant: "h4", children: e.title }),
      /* @__PURE__ */ a.jsx(Se, { "aria-label": "close", onClick: e.handleCancel, disabled: e.disableCancel, children: /* @__PURE__ */ a.jsx(B, { children: /* @__PURE__ */ a.jsx("path", { d: ft }) }) })
    ] })
  ] });
}, $n = h((e) => ({
  dialogTitle: {
    padding: "14px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0px 3px 3px rgba(0, 0, 0, 0.03)",
    backgroundFilter: "blur(25px)",
    backgroundColor: "rgba(255,255,255,.8)"
  },
  displayMobile: {
    marginTop: 20,
    [e.breakpoints.up("md")]: {
      display: "none"
    }
  },
  displayDesktop: {
    [e.breakpoints.down("md")]: {
      display: "none"
    }
  }
})), Dr = (e) => {
  const n = Bn();
  return /* @__PURE__ */ a.jsxs("div", { className: n.dialogTitle, children: [
    /* @__PURE__ */ a.jsx("div", { className: n.hidden }),
    /* @__PURE__ */ a.jsx(P, { variant: "h4", component: "div", className: n.h4, children: e.title }),
    /* @__PURE__ */ a.jsx(Se, { "aria-label": "close", className: n.closeButton, onClick: e.closeDialog, children: /* @__PURE__ */ a.jsx(B, { children: /* @__PURE__ */ a.jsx("path", { d: ft }) }) })
  ] });
}, Bn = h((e) => ({
  hidden: {
    width: "48px",
    height: "1px",
    [e.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  closeButton: {
    padding: 0,
    color: r.GRAY_SHADE
  },
  dialogTitle: {
    padding: 15,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0px 3px 3px rgba(0, 0, 0, 0.03)",
    [e.breakpoints.up("md")]: {
      boxShadow: "none"
    }
  },
  h4: {
    color: r.GRAY_SHADE,
    [e.breakpoints.up("md")]: {
      flex: 1,
      textAlign: "center"
    }
  }
})), Fn = (e, n) => e === 0 ? 0 : e >= n ? 100 : e / n * 100, Ir = (e) => {
  const n = Wn({
    barHeight: e.barHeight ? e.barHeight : 10
  }), i = 6, l = Fn(e.total, e.goal), b = l > 0 && l < i ? i : l;
  return /* @__PURE__ */ a.jsx("div", { className: n.donationGraphContainer, children: /* @__PURE__ */ a.jsx("div", { className: n.donationGraphBase, children: /* @__PURE__ */ a.jsx("div", { className: n.dontaionGraphFill, style: { width: `${b}%` } }) }) });
}, Wn = h((e) => ({
  donationGraphBase: {
    width: "100%",
    position: "relative",
    borderRadius: (n) => n.barHeight / 2,
    height: (n) => n.barHeight,
    backgroundColor: "rgba(0,0,0,.1)"
  },
  dontaionGraphFill: {
    transition: "width 2s ease-in-out",
    borderRadius: (n) => n.barHeight / 2,
    height: (n) => n.barHeight,
    position: "absolute",
    backgroundColor: r.PRIMARY
  },
  donationGraphContainer: {}
})), Xe = (e, n = !0) => Intl.NumberFormat("en-us", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: n ? 2 : 0
}).format(e);
var xe = /* @__PURE__ */ ((e) => (e[e.price = 0] = "price", e[e.number = 1] = "number", e))(xe || {});
const et = (e, n) => n === 0 ? e > 0 ? e / 100 : 0 : e, Pr = (e) => {
  const n = Mn();
  return /* @__PURE__ */ a.jsxs("div", { className: n.donationGoal, children: [
    /* @__PURE__ */ a.jsx(P, { variant: "h5", children: Xe(et(e.totalRaised || 0, xe.price), !1) }),
    /* @__PURE__ */ a.jsxs(dt, { className: n.p3DonationGoal, children: [
      "of",
      ` ${Xe(et(e.goal, xe.price), !1)}`,
      " goal"
    ] })
  ] });
}, Mn = h((e) => ({
  donationGoal: {
    paddingBottom: 5,
    display: "flex",
    alignItems: "center"
  },
  p3DonationGoal: {
    color: r.LIGHT_GRAY,
    paddingLeft: 5,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }
})), Gr = (e) => {
  const n = zn();
  return /* @__PURE__ */ a.jsx(B, { className: T(n.infoIcon, e.className), children: /* @__PURE__ */ a.jsx("path", { d: mn }) });
}, zn = h((e) => ({
  infoIcon: {
    marginLeft: 5,
    marginRight: 5,
    width: 10,
    height: 10,
    color: r.LIGHT_GRAY
  }
})), Yr = (e) => {
  const n = Un();
  return /* @__PURE__ */ a.jsx("div", { className: T(n.hr, e.className) });
}, Un = h((e) => ({
  hr: {
    margin: "10px 0",
    width: "100%",
    height: 1,
    backgroundColor: "rgba(48, 46, 40, 0.1)"
  }
})), Hr = (e) => {
  const n = Vn();
  return /* @__PURE__ */ a.jsx(
    Mt,
    {
      onClose: e.handleClose,
      open: !!e.anchorEl,
      anchorEl: e.anchorEl,
      classes: {
        paper: n.popoverContainer,
        ...e.classes
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
        ...e.anchorOrigin
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "right",
        ...e.transformOrigin
      },
      children: e.children
    }
  );
}, Vn = h(() => ({
  popoverContainer: {
    borderRadius: 8,
    padding: 8,
    minWidth: 200,
    display: "grid",
    gridTemplateColumns: "repeat(1, 1fr)",
    gap: "8px"
  },
  divider: {
    width: "100%",
    height: 1,
    backgroundColor: "rgba(48, 46, 40, 0.1)"
  }
})), qn = zt(
  (e) => Ut({
    root: {
      width: 20,
      height: 20,
      border: `2px solid ${e.palette.background.paper}`
    }
  })
)(se), Lr = (e) => {
  const n = Kn();
  return /* @__PURE__ */ a.jsxs("div", { className: T(n.photoAndDetailContainer, e.containerClass), children: [
    e.avatarEl && /* @__PURE__ */ a.jsx(se, { className: T(e.avatarClass, n.avatar), children: e.avatarEl }),
    e.badge && /* @__PURE__ */ a.jsx(
      Vt,
      {
        overlap: "circular",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        badgeContent: /* @__PURE__ */ a.jsx(qn, { alt: "4G", src: e.badge }),
        children: /* @__PURE__ */ a.jsx(
          Qe,
          {
            size: "medium",
            label: e.avatarString || "",
            type: e.avatarType === "self" ? "user" : "other",
            className: n.avatar,
            url: e.avatarSrc
          }
        )
      }
    ),
    !e.badge && !e.avatarEl && /* @__PURE__ */ a.jsx(
      Qe,
      {
        size: "medium",
        label: e.avatarString || "",
        type: e.avatarType === "self" ? "user" : "other",
        className: n.avatar,
        url: e.avatarSrc
      }
    ),
    /* @__PURE__ */ a.jsx("div", { className: n.details, children: e.children }),
    e.onClick && /* @__PURE__ */ a.jsx(
      Se,
      {
        className: n.icon,
        onClick: (i) => {
          i.preventDefault(), i.stopPropagation(), e.onClick && e.onClick(i);
        },
        children: /* @__PURE__ */ a.jsx(B, { children: /* @__PURE__ */ a.jsx("path", { d: bn }) })
      }
    )
  ] });
}, Kn = h((e) => ({
  photoAndDetailContainer: {
    display: "flex",
    alignItems: "center"
  },
  avatar: {
    border: `1px solid ${r.TRANSPARENT_BORDER}`,
    width: 35,
    height: 35
  },
  details: {
    flex: 1,
    paddingLeft: 10,
    paddingRight: 10
  },
  icon: {
    padding: 0,
    color: r.LIGHT_GRAY
  }
})), $r = V.forwardRef((e, n) => {
  const { inputProps: i, ...l } = e, b = Jn();
  return /* @__PURE__ */ a.jsx(
    qt,
    {
      ref: n,
      variant: "outlined",
      classes: {
        root: b.root
      },
      ...l,
      inputProps: {
        autoCorrect: "off",
        autoCapitalize: "none",
        className: b.inputClass,
        ...i
      },
      InputLabelProps: {
        ...e.InputLabelProps,
        className: b.labelClass
      }
    }
  );
}), Jn = h((e) => ({
  root: {
    borderRadius: 8,
    "& .MuiInputBase-input": {
      borderRadius: 8,
      padding: "16px 14px",
      height: "auto",
      minHeight: 24
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fff",
      borderRadius: 8
    },
    "& .MuiOutlinedInput-multiline": {
      backgroundColor: "#fff",
      padding: 0
    },
    "& .MuiOutlinedInput-multiline textarea": {
      backgroundColor: "#fff",
      padding: "9.5px 14px"
    },
    "& .Mui-disabled": {
      color: r.GRAY_SHADE
    },
    "& .MuiInputBase-root fieldset legend span": {
      // This is a hidden label that is creating space for the animated label
      // that's defined by "shrink"
      fontSize: 13,
      fontWeight: "600"
    },
    "& .MuiInputLabel-shrink": {
      fontWeight: 600,
      color: r.GRAY_SHADE
    },
    "& .MuiFormHelperText-root": {
      fontSize: 10,
      lineHeight: c(15),
      color: r.GRAY
    },
    "& .MuiFormHelperText-root.Mui-error": {
      fontSize: 10,
      lineHeight: c(15),
      color: r.ERROR
    },
    "& .Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: `${r.PRIMARY} !important`
      }
    },
    "& .MuiOutlinedInput-notchedOutline": {
      top: -6,
      borderColor: r.TRANSPARENT_BORDER
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(48, 46, 40, 0.2)"
    }
  },
  inputClass: {
    fontSize: 16,
    borderRadius: 8
  },
  labelClass: {
    color: r.GRAY_SHADE,
    transform: "translate(14px, 11px) scale(1)"
  }
})), Br = () => {
  const e = ae.get("giving-public");
  return rt(() => {
    if (e)
      try {
        return JSON.parse(e);
      } catch {
        return;
      }
  }, [e]);
};
function tt() {
  return typeof document < "u" ? document.hasFocus() : !1;
}
function Zn() {
  return typeof document < "u" ? document : !1;
}
function nt() {
  return typeof window < "u" ? document : !1;
}
const Qn = () => {
  const [e, n] = Z(tt()), i = () => n(tt());
  return z(() => {
    const l = nt();
    return l && (l.addEventListener("visibilitychange", i, !1), l.addEventListener("focus", i, !1), l.addEventListener("blur", i, !1)), () => {
      const b = Zn();
      b && b.removeEventListener("visibilitychange", i);
      const g = nt();
      g && (g.removeEventListener("blur", i), g.removeEventListener("focus", i));
    };
  }, []), e;
}, U = {
  STAGING: "staging",
  PRODUCTION: "production",
  LOCAL: "local"
}, Re = process.env.NEXT_PUBLIC_BUILD_ENV ? process.env.NEXT_PUBLIC_BUILD_ENV : sn("REACT_APP_BUILD_ENV"), Xn = () => Re === "dev" ? U.LOCAL : Re === "STAGING" ? U.STAGING : Re === "PROD" ? U.PRODUCTION : U.LOCAL, er = () => {
  switch (Xn()) {
    case U.PRODUCTION:
      return "https://prod--services.4giving.com";
    case U.STAGING:
      return "https://staging--services.4giving.com";
    default:
      return "https://dev.4giving.com:3000";
  }
}, tr = er(), _e = async (e) => {
  const n = {
    method: e.method,
    url: `${tr}${e.endpoint}`,
    timeout: e.timeout ? e.timeout : 3e4
    // Default 30 second timeout
  };
  return e.data && (n.data = e.data), e.authToken && (n.headers = {
    Authorization: `Bearer ${e.authToken}`
  }), n.withCredentials = !0, Qt(n);
}, Fr = Object.freeze({
  executeApi: _e
}), nr = async (e) => (await _e({
  endpoint: "/user/exchange",
  method: "POST",
  authToken: e
})).data, rr = () => lt(["exchange"], (e) => nr(e.authToken), {
  onSuccess: (e, n) => {
    n.invalidateQueries && ct.invalidateQueries();
  }
}), or = async () => (await _e({
  endpoint: "/user/exchange",
  method: "DELETE"
})).data, ar = () => lt(["exchange"], or, {
  onSuccess: () => {
    ct.invalidateQueries();
  }
}), gt = V.createContext({
  isAuthenticated: !1
}), Wr = (e) => {
  const [n, i] = Z(), [l, b] = Z(void 0), [g, S] = Z(!1), { mutate: p, isSuccess: x } = rr(), { mutateAsync: y } = ar(), v = Qn(), [E, w] = Z(void 0);
  z(() => {
    v && E && x && (ae.get("giving-public") || window.location.reload());
  }, [v, E, x]), z(() => {
    const j = ae.get("giving-public");
    if (j)
      try {
        const I = JSON.parse(j);
        b(I);
      } catch (I) {
        console.log(I);
      }
    (async () => {
      var X;
      const I = await e.authClient();
      if (i(I), window.location.search.includes("code=") && window.location.search.includes("state=")) {
        const N = await I.handleRedirectCallback();
        (X = N == null ? void 0 : N.appState) != null && X.targetUrl && e.handleNav(N.appState.targetUrl, {
          replace: !0
        });
      }
      const le = await I.isAuthenticated();
      S(le);
    })();
  }, []), z(() => {
    g && n && n.getTokenSilently().then((j) => {
      w(j);
    });
  }, [g, n]), z(() => {
    E && E !== void 0 && p({
      authToken: E,
      invalidateQueries: !l
    });
  }, [E]), z(() => {
    if (x && !l) {
      const j = ae.get("giving-public");
      if (j)
        try {
          const C = JSON.parse(j);
          b(C);
        } catch (C) {
          console.log(C);
        }
    }
  }, [x]);
  const D = oe(() => n ? n.loginWithRedirect({
    authorizationParams: {
      redirect_uri: e.auth0RedirectUri
    },
    appState: { targetUrl: window.location.pathname }
  }) : () => {
  }, [n]), $ = oe(() => n ? n.loginWithRedirect({
    authorizationParams: {
      screen_hint: "signup",
      prompt: "login",
      redirect_uri: e.auth0RedirectUri
    },
    appState: { targetUrl: window.location.pathname }
  }) : () => {
  }, [n]), q = oe(
    (j) => n ? n.loginWithRedirect({
      authorizationParams: {
        screen_hint: "signup",
        prompt: "login",
        redirect_uri: e.auth0RedirectUri
      },
      appState: { targetUrl: j }
    }) : () => {
    },
    [n]
  ), K = oe(async () => (n && (await y(), n.logout({
    logoutParams: {
      returnTo: `${e.auth0RedirectUri}${e.auth0LogoutAddt}`
    }
  })), () => {
  }), [n]), Q = rt(() => l ? {
    isAuthenticated: !0,
    login: D,
    logout: K,
    signUp: $,
    joinSignUp: q,
    ...l
  } : {
    isAuthenticated: !1,
    login: D,
    logout: K,
    joinSignUp: q,
    signUp: $
  }, [n, l]);
  return /* @__PURE__ */ a.jsx(gt.Provider, { value: Q, children: e.children });
}, Mr = () => $t(gt);
export {
  Wr as AuthProvider,
  Qe as Avatar,
  L as ButtonBase,
  pr as Card,
  xr as CharacterCount,
  Cr as ContainerNoEntries,
  br as DEFAULT_THEME,
  yr as DangerButton,
  Ar as DialogBase,
  jr as DialogHelpActionBar,
  Or as DialogSecondaryActionBar,
  Nr as DialogTitleActionHeader,
  Dr as DialogTitleHeader,
  Ir as DonationBar,
  Pr as DonationBarHeader,
  Gr as Dot,
  mr as H7,
  vr as Handwritten,
  Yr as HorizontalRule,
  $r as InputField,
  In as IntegratedButton,
  Hr as MenuPopover,
  Tr as NakedButton,
  dn as NavTitle,
  dt as P3,
  rn as P4,
  Er as PaperButton,
  Lr as PhotoAndDetails,
  Sr as PopoverMenuButton,
  Tn as PrimaryButton,
  r as SYSTEM_COLORS,
  ht as SecondaryButton,
  wr as SegmentedButtonControl,
  Rr as SmallText,
  _r as TabButton,
  ie as TransparentButton,
  kr as WarningButton,
  Fr as executeApi,
  sn as findEnvAttr,
  c as getRemFromPx,
  Mr as useAuth,
  Br as useAuthCookie,
  Qn as useIsVisible
};
